import React from 'react'
import { COLORS } from '@helpers/constants'
import Icon from '@components/Icon'

const LeftNav = ({onClick, disabled}) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className="ml-4 rounded-full transition-all cursor-pointer absolute z-[4] outline-none bg-black top-1/2 transform translate-y-[-50%] w-[76px] h-[76px]"
        disabled={disabled}
        onClick={onClick}
        aria-label="Previous Slide"
      >
        <div className="flex justify-center w-full">
          <Icon icon={'ChevronLeftBig'} color={disabled ? COLORS.LIGHT_DARK_GREY.TEXT : COLORS.WHITE.TEXT} />
        </div>
      </button>
    </div>
  )
}

LeftNav.displayName = 'LeftNav'

const MemoizedLeftNav = React.memo(LeftNav)
export default MemoizedLeftNav

// export default LeftNav
